import { DataSource } from '~/Api/DataSource';
import Price from '~/libs/Price';

import { Error, ErrorCode } from './Error';

interface FinalCalculationProduct {
	readonly id: string;
	readonly dataSource: DataSource;
	readonly samePackageSize: boolean;
}

interface ReferencedProduct {
	readonly id: string;
	readonly dataSource: DataSource;
	readonly currentExFactoryPrice: Price | null;
}

export class FinalCalculation {
	constructor(
		public readonly emptyResultReason: Error[],
		public readonly priceDropPercents: number | null,
		public readonly ercPriceDropPercents: number | null,
		public readonly referencedProduct: ReferencedProduct | null,
		public readonly threeLowestPricesAvg: {
			price: Price;
			ercPrice: Price;
			fromProducts: FinalCalculationProduct[];
			ercFromProducts: FinalCalculationProduct[];
		} | null
	) {}

	requiresReferenceSettings(): boolean {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.RequiresReferenceSettings) !== undefined;
	}

	requiresProductSettings(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.RequiredProductSettingsMissingErrorCode) !==
			undefined
		);
	}

	requiresOnlyOneProductPerCountry(): Error | null {
		return this.emptyResultReason.find((error) => error.code === ErrorCode.OnlyOneProductPerCountryErrorCode) ?? null;
	}

	requiresAtLeastOneReferenceCountryProduct(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.AtLeastOneReferenceCountryProduct) !== undefined
		);
	}

	illegalPriceTypeSelected(): boolean {
		return (
			this.emptyResultReason.find((error) => error.code === ErrorCode.IllegalPriceTypeSelectedErrorCode) !== undefined
		);
	}
}
